import LoadingSpinner from './LoadingSpinner';
import { LoadingSpinnerProps, LoadingSpinnerValueProps } from './types';

export type { LoadingSpinnerProps, LoadingSpinnerValueProps };
export default LoadingSpinner;
